export default __webpack_public_path__ + "static/media/medProsLogoSmall.8e26fe6e.svg";